import React, { useState } from 'react';
import { TooltipContainer, TooltipBox, TooltipArrow } from './tooltip.styled';
var Tooltip = function Tooltip(_ref) {
    var handleMouseLeave = _ref.handleMouseLeave, children = _ref.children, text = _ref.text;
    var _useState = useState(false), show = _useState[0], setShow = _useState[1];
    var onMouseEnter = function onMouseEnter() {
        setShow(true);
    };
    var onMouseLeave = function onMouseLeave() {
        setShow(false);
        if (handleMouseLeave) {
            handleMouseLeave();
        }
    };
    return /*#__PURE__*/ React.createElement(TooltipContainer, null, /*#__PURE__*/ React.createElement(TooltipBox, {
        isVisible: show
    }, text, /*#__PURE__*/ React.createElement(TooltipArrow, null)), /*#__PURE__*/ React.createElement("div", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, children));
};
export default Tooltip;
